import {
  TableSelectionControl,
  type TableSelectionControlProps,
} from "@/features/invoices/components/TableSelectionControl";
import { DOWNLOAD_LIST_PAGE_SIZES } from "@/domain/invoices/downloadListPageSize";
import type { ReactNode } from "react";

interface InvoiceTableToolbarProps {
  pageSize: number;
  search: string;
  onPageSizeChange: (size: number) => void;
  onSearchChange: (q: string) => void;
  findPlaceholder?: string;
  findTitle?: string;
  selection: Pick<
    TableSelectionControlProps,
    | "pageSelectableCount"
    | "allOnPageSelected"
    | "someOnPageSelected"
    | "onTogglePage"
    | "onSelectAllPages"
    | "allPagesDisabled"
    | "allPagesActive"
    | "loadedPagesSelectableCount"
    | "totalSelectedCount"
    | "onClearSelection"
    | "allPagesTitle"
  >;
  /** Export ZIP or other primary action on the right (compact download layout). */
  trailing?: ReactNode;
}

export function InvoiceTableToolbar({
  pageSize,
  search,
  onPageSizeChange,
  onSearchChange,
  findPlaceholder = "Invoice number…",
  findTitle = "Client-side — current page only. Matches invoice number (partial OK).",
  selection,
  trailing,
}: InvoiceTableToolbarProps) {
  return (
    <div className="table-toolbar">
      <div className="left">
        <label className="flex items-center gap-2 text-[var(--muted)]">
          Show
          <select value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))}>
            {DOWNLOAD_LIST_PAGE_SIZES.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          entries
        </label>
        <label className="table-find-label">
          Find in table
          <input
            type="search"
            placeholder={findPlaceholder}
            title={findTitle}
            className="min-w-[12rem]"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </label>
      </div>
      <div className="table-toolbar-right">
        <TableSelectionControl {...selection} />
        {trailing}
      </div>
    </div>
  );
}
